module.exports = __webpack_public_path__ + "img/la.bc84c5bf.svg";